module.exports = __webpack_public_path__ + "img/elo.afb6f24f.svg";